// Version: 3.0.7 - September 27, 2021 16:12:13
class MessageDispatcher {
    constructor(win = window) {
        this.addListener = (listener) => {
            this.listeners.push(listener);
            return listener;
        };
        this.removeListener = (listener) => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
        this.listen = () => {
            this.window.addEventListener('message', this.receive, false);
        };
        this.unlisten = () => {
            this.window.removeEventListener('message', this.receive);
        };
        this.receive = (event) => {
            const listener = this.listeners.find(l => ( l.iFrame.contentWindow === event.source));
            if (typeof event.data !== 'string' ||
                event.data.substr(0, 11) !== 'appointlet:' ||
                !listener)
                return;
            const message = JSON.parse(event.data.substr(11));
            listener.callback(message);
        };
        this.window = win;
        this.listeners = [];
        this.listen();
    }
}
var messageDispatcher = new MessageDispatcher();

class SDK {
    constructor(schedulingPageURL) {
        this.schedulingPageURL = schedulingPageURL;
        this.__TIMEOUT__ = 30000;
        this.listenForLoadedOrTimeOut = async (iFrame) => {
            return new Promise((resolve, reject) => {
                const listener = messageDispatcher.addListener({
                    iFrame,
                    callback: message => {
                        if (message.type === 'scheduler:loaded') {
                            resolve();
                            messageDispatcher.removeListener(listener);
                        }
                    },
                });
                setTimeout(reject, this.__TIMEOUT__);
            });
        };
        this.listenForCompletionOrAbandon = async (iFrame) => {
            return new Promise(resolve => {
                const listener = messageDispatcher.addListener({
                    iFrame,
                    callback: message => {
                        if (message.type === 'booking:created') {
                            resolve(message.data);
                            messageDispatcher.removeListener(listener);
                        }
                        if (message.type === 'scheduler:close') {
                            resolve(null);
                            const body = document.body;
                            messageDispatcher.removeListener(listener);
                            body.classList.remove('modal-open');
                        }
                    },
                });
            });
        };
        this.url = schedulingPageURL;
    }
    async inlineEmbed(el) {
        const iFrame = document.createElement('iframe');
        iFrame.setAttribute('src', this.getURLWithModeAndVersion('inline'));
        iFrame.classList.add('appointlet-iframe', 'appointlet-inline');
        el.appendChild(iFrame);
        try {
            await this.listenForLoadedOrTimeOut(iFrame);
        }
        catch (e) {
            iFrame.remove();
            throw new Error(`[@appointlet/appointlet.js]:\n\nFailed to load scheduler`);
        }
        const attendee = await this.listenForCompletionOrAbandon(iFrame);
        if (attendee && attendee.redirectUrl) {
            window.location.assign(attendee.redirectUrl);
        }
        return attendee;
    }
    async openModal() {
        const backdrop = document.createElement('div');
        const body = document.body;
        backdrop.classList.add('appointlet-popover-backdrop');
        body.appendChild(backdrop);
        const loader = document.createElement('div');
        loader.classList.add('appointlet-loader');
        backdrop.appendChild(loader);
        body.classList.add('modal-open');
        const iFrame = document.createElement('iframe');
        iFrame.setAttribute('src', this.getURLWithModeAndVersion('modal'));
        iFrame.classList.add('appointlet-iframe', 'appointlet-popover');
        body.appendChild(iFrame);
        try {
            await this.listenForLoadedOrTimeOut(iFrame);
        }
        catch (e) {
            iFrame.remove();
            loader.remove();
            backdrop.remove();
            throw new Error(`[@appointlet/appointlet.js]:\n\nFailed to load scheduler`);
        }
        iFrame.style.display = 'block';
        let modalOpen = true;
        let completedBooking = null;
        while (modalOpen) {
            let response = await this.listenForCompletionOrAbandon(iFrame);
            if (response === null) {
                modalOpen = false;
            }
            else {
                completedBooking = response;
            }
            if (completedBooking && completedBooking.redirectUrl) {
                window.location.assign(completedBooking.redirectUrl);
            }
        }
        iFrame.remove();
        loader.remove();
        backdrop.remove();
        return completedBooking;
    }
    getURLWithModeAndVersion(mode) {
        return `${this.url}${this.url.indexOf("?") > -1 ? "&" : "?"}mode=${mode}&v=3.0.7`;
    }
}

export default SDK;
